(function () {
  function selectVariantByTitle(title) {
    if (!title) return false;

    const escaped = CSS.escape(title);
    const radio = document.querySelector(
      `.product-form__input input[type="radio"][value="${escaped}"]`
    );

    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    const select = document.querySelector('select[name="id"]');
    if (select) {
      const option = [...select.options].find((opt) => opt.textContent.trim() === title);
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function selectVariantById(variantId) {
    if (!variantId) return false;
    const select = document.querySelector('select[name="id"]');
    if (select) {
      const option = [...select.options].find((opt) => String(opt.value) === String(variantId));
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function initRepairCards() {
    const cards = document.querySelectorAll('.hybrid-card[data-variant-title], .hybrid-card[data-variant-id]');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');

      const activate = () => {
        const title = card.dataset.variantTitle;
        const variantId = card.dataset.variantId;
        const isGeneric = card.dataset.variantGeneric === 'true';

        let selected = false;
        if (!isGeneric && title) {
          selected = selectVariantByTitle(title);
        }
        if (!selected && variantId) {
          selected = selectVariantById(variantId);
        }
        if (!selected && title) {
          selected = selectVariantByTitle(title);
        }
        if (!selected) return;

        cards.forEach((c) => c.classList.remove('hybrid-card--active'));
        card.classList.add('hybrid-card--active');

        document.querySelector('.product-form, variant-selects')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      };

      card.addEventListener('click', activate);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      });
    });

    const checked = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (checked) {
      const active = [...cards].find((c) => c.dataset.variantTitle === checked.value);
      active?.classList.add('hybrid-card--active');
    }
  }

  /**
   * SEO hygiene for Shopify description HTML:
   * - demote leftover H1 → H2 inside description root
   * - ensure nested section headings under a parent H2 become H3
   *   (only for headings that are not already accordion titles)
   */
  function normalizeDescriptionHeadings() {
    document.querySelectorAll('[data-repair-desc-root]').forEach((root) => {
      root.querySelectorAll('h1').forEach((el) => {
        const h2 = document.createElement('h2');
        h2.innerHTML = el.innerHTML;
        [...el.attributes].forEach((attr) => h2.setAttribute(attr.name, attr.value));
        el.replaceWith(h2);
      });

      const hasH2 = root.querySelector('h2');
      if (!hasH2) return;

      root.querySelectorAll('h2').forEach((h2, index) => {
        if (index === 0) return;
        // Secondary H2s in long product HTML → H3 for clean hierarchy
        const h3 = document.createElement('h3');
        h3.innerHTML = h2.innerHTML;
        [...h2.attributes].forEach((attr) => h3.setAttribute(attr.name, attr.value));
        h2.replaceWith(h3);
      });
    });
  }

  /**
   * Product body HTML often ships with literal "• " inside <li>, while theme CSS
   * already paints blue checkmarks. Strip the duplicate text markers.
   */
  function stripDuplicateListMarkers() {
    const roots = document.querySelectorAll(
      '[data-repair-desc-root], .repair-hybrid-container--embedded, .repair-hybrid__content, .product__description'
    );
    roots.forEach((root) => {
      root.querySelectorAll('li').forEach((li) => {
        // Prefer first text node so we don't touch nested HTML
        for (const node of li.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          const cleaned = node.textContent.replace(/^[\s\u00A0]*[•·▪●✓✔✅]\s*/u, '');
          if (cleaned !== node.textContent) {
            node.textContent = cleaned;
          }
          break;
        }
      });
    });
  }

  const MONO_ICONS = {
    arrow:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h12"/><path d="M13 6l6 6-6 6"/></svg>',
    tools:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.2 5.2L4 17l3 3 5.5-5.5a4 4 0 0 0 5.2-5.2l-2.5 2.5-2.5-2.5 2.5-2.5z"/></svg>',
    check:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M8.5 12.2l2.3 2.3 4.7-4.8"/></svg>',
    phone:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="3" width="8" height="18" rx="2"/><path d="M11 18h2"/></svg>',
    shield:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/></svg>',
    clock:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l2.5 1.5"/></svg>',
    spark:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.2 4.2L17.5 8.5 13.2 9.8 12 14l-1.2-4.2L6.5 8.5l4.3-1.3L12 3z"/><path d="M18 14l.6 2.1L20.5 17l-1.9.6L18 19.5l-.6-1.9L15.5 17l1.9-.9L18 14z"/></svg>',
  };

  // Common Apple-style / product-HTML emojis → monoline icon keys
  const EMOJI_MAP = [
    { re: /[\u{1F449}\u{27A1}\u{1F6C8}\u{25B6}][\u{FE0F}]?/gu, icon: 'arrow' },
    { re: /[\u{1F6E0}\u{1F527}\u{2692}\u{1F528}][\u{FE0F}]?/gu, icon: 'tools' },
    { re: /[\u{2705}\u{2714}\u{2611}\u{1F7E2}][\u{FE0F}]?/gu, icon: 'check' },
    { re: /[\u{1F4F1}\u{1F4F2}\u{260E}][\u{FE0F}]?/gu, icon: 'phone' },
    { re: /[\u{1F6E1}\u{1F512}\u{1F510}][\u{FE0F}]?/gu, icon: 'shield' },
    { re: /[\u{23F1}\u{23F0}\u{1F550}\u{1F55B}\u{231A}\u{231B}][\u{FE0F}]?/gu, icon: 'clock' },
    { re: /[\u{2728}\u{2B50}\u{1F31F}\u{26A1}][\u{FE0F}]?/gu, icon: 'spark' },
  ];

  function iconSpan(iconKey) {
    const span = document.createElement('span');
    span.className = 'repair-desc-mono-icon';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = MONO_ICONS[iconKey] || MONO_ICONS.spark;
    return span;
  }

  /**
   * Replace Apple-color emojis in repair description HTML with monoline SVGs
   * matching the accordion / upsell icon language.
   */
  function restyleDescriptionEmojis() {
    const roots = document.querySelectorAll(
      '[data-repair-desc-root], .repair-hybrid-container--embedded, .repair-hybrid__content'
    );

    roots.forEach((root) => {
      if (root.dataset.repairEmojisDone === '1') return;
      root.dataset.repairEmojisDone = '1';

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.parentElement) return NodeFilter.FILTER_REJECT;
          const tag = node.parentElement.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'SVG' || tag === 'TEXTAREA') {
            return NodeFilter.FILTER_REJECT;
          }
          if (node.parentElement.closest('.repair-desc-mono-icon, .repair-desc-accordion__icon')) {
            return NodeFilter.FILTER_REJECT;
          }
          // Skip trust pills — they already use CSS marks
          if (node.parentElement.closest('.repair-hybrid__trust')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      });

      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((textNode) => {
        let text = textNode.textContent;
        if (!text || !/\p{Extended_Pictographic}|[\u2705\u2714\u27A1\u2611]/u.test(text)) return;

        // Build a fragment, swapping matched emojis for icon spans
        const frag = document.createDocumentFragment();
        let cursor = 0;
        let matchedAny = false;

        // Combined matcher over all emoji patterns
        const combined = new RegExp(
          EMOJI_MAP.map((m) => `(${m.re.source})`).join('|'),
          'gu'
        );

        let match;
        while ((match = combined.exec(text)) !== null) {
          matchedAny = true;
          if (match.index > cursor) {
            frag.appendChild(document.createTextNode(text.slice(cursor, match.index)));
          }

          let iconKey = 'spark';
          for (let i = 0; i < EMOJI_MAP.length; i++) {
            if (match[i + 1] != null) {
              iconKey = EMOJI_MAP[i].icon;
              break;
            }
          }

          // Leading checkmarks inside <li> are already drawn by CSS — drop them
          const inLi = textNode.parentElement && textNode.parentElement.closest('li');
          const isLeading =
            inLi &&
            match.index === 0 &&
            iconKey === 'check' &&
            !textNode.previousSibling;

          if (!isLeading) {
            frag.appendChild(iconSpan(iconKey));
          }

          // Drop trailing spaces after replaced emoji so spacing looks intentional
          let next = match.index + match[0].length;
          while (text[next] === ' ' || text[next] === '\u00A0') next += 1;
          cursor = next;
          combined.lastIndex = next;
        }

        if (!matchedAny) return;

        if (cursor < text.length) {
          frag.appendChild(document.createTextNode(text.slice(cursor)));
        }

        textNode.replaceWith(frag);
      });
    });
  }

  function initRepairDescription() {
    stripDuplicateListMarkers();
    restyleDescriptionEmojis();
    normalizeDescriptionHeadings();
    initRepairCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRepairDescription);
  } else {
    initRepairDescription();
  }

  document.addEventListener('shopify:section:load', initRepairDescription);
})();
